import { useQuery } from 'react-query';
import API from '../api/phx';

const fetchSettings = async () => {
  const res = await API.get(`/payments/checkoutdotcom/settings`);
  return res.data;
};

export const useSettings = () => {
  return useQuery(['settings'], fetchSettings);
};


export default useSettings;